<div class="lightbox-backdrop" (click)="close()">
  <div class="lightbox-container" (click)="$event.stopPropagation()">
    <button class="lightbox-close" (click)="close()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
    <button *ngIf="showDownload" class="lightbox-download" (click)="download()" [disabled]="downloading" title="Bild herunterladen">
      <ion-icon [name]="downloading ? 'hourglass-outline' : 'download-outline'"></ion-icon>
    </button>

    <button class="lightbox-nav prev" (click)="prev()" [disabled]="currentIndex === 0">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>

    <div class="lightbox-image-wrap">
      <img [src]="current" class="lightbox-image" (error)="$any($event.target).style.display='none'" />
    </div>

    <button class="lightbox-nav next" (click)="next()" [disabled]="currentIndex === images.length - 1">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>

    <div class="lightbox-counter" *ngIf="images.length > 1">
      {{ currentIndex + 1 }} / {{ images.length }}
    </div>

    <div class="lightbox-thumbs" *ngIf="images.length > 1">
      <img
        *ngFor="let img of images; let i = index"
        [src]="img"
        class="lightbox-thumb"
        [class.active]="i === currentIndex"
        (click)="currentIndex = i"
        (error)="$any($event.target).style.display='none'"
      />
    </div>
  </div>
</div>
